module.exports = __webpack_public_path__ + "static/media/project-05.0a4c7521.png";